import React, { useEffect, useState } from 'react'
import DeckFilter from './DeckFilter'
import DecksLists from './DecksLists'
import { IDeckStatus } from './types'
import { sendSystemLog } from '../../context/AuthProvider/useAuth'

function index() {
  const [decks, setDecks] = useState<IDeckStatus[]>([])
  const [generatedAt, setGeneratedAt] = useState("")
  const log = {
    log_type: 'visited',
    log_object: 'decks_status'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  
  return (
    <div className="deck-status">
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <DeckFilter setDecks={setDecks} setGeneratedAt={setGeneratedAt} />
        {generatedAt && <DecksLists decks={decks} generatedAt={generatedAt}/>}
    </div>
  )
}

export default index